<template>
  <div class="make-form-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <h2 class="page-title">
            <i class="el-icon-edit"></i>
            {{make_form_title}}
          </h2>
        </div>

        <!-- 表单内容区 -->
        <div class="form-card">
          <el-form ref="editForm" :model="editForm" :rules="form_rules" size="small" label-position="top">
            
            <!-- 基本信息区 -->
            <div class="form-section">
              <h3 class="section-title">
                <span class="section-num">1</span>
                基本信息
              </h3>
              <div class="form-grid">
                <el-form-item label="表格名称" :required="true" class="form-item-full">
                  <el-input 
                    v-model="editForm.form_name" 
                    placeholder="请输入表格名称，如：学生信息收集表"
                    prefix-icon="el-icon-document">
                  </el-input>
                </el-form-item>

                <el-form-item label="领表须知（选填）">
                  <el-input 
                    type="textarea" 
                    :rows="2" 
                    v-model="editForm.recieve_notice" 
                    placeholder="填写领表时的提示说明，会在填表人领表时显示">
                  </el-input>
                </el-form-item>

                <el-form-item label="填表须知（选填）">
                  <el-input 
                    type="textarea" 
                    :rows="2" 
                    v-model="editForm.form_comment" 
                    placeholder="填写填表时的提示说明，会在填表人填表时显示">
                  </el-input>
                </el-form-item>
              </div>
            </div>

            <!-- 数据列配置区 -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <span class="section-num">2</span>
                  数据列配置
                  <span class="required-tag">必填</span>
                </h3>
                <el-button type="primary" class="btn-primary-custom" @click="showAddColumnDialog()">
                  <i class="el-icon-plus"></i> 添加数据列
                </el-button>
              </div>

              <!-- 数据列表 -->
              <div class="table-wrapper">
                <el-table 
                  ref="column_form" 
                  :data="columnData" 
                  stripe 
                  class="column-table"
                  :header-cell-class-name="'table-header'">
                  
                  <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="scope">
                      <span class="row-num">{{scope.$index+1}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="column_name" label="数据列名" min-width="150">
                  </el-table-column>

                  <el-table-column prop="column_type" label="数据格式" width="120" align="center">
                    <template slot-scope="scope">
                      <span class="type-tag">{{scope.row.column_type}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="column_optional" label="是否必填" width="100" align="center">
                    <template slot-scope="scope">
                      <span class="status-badge" :class="scope.row.column_optional == '1' ? 'optional' : 'required'">
                        {{scope.row.column_optional == '1' ? '选填' : '必填'}}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="column_comment" label="填写说明" min-width="150">
                    <template slot-scope="scope">
                      <span class="comment-text">{{scope.row.column_comment || '-'}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="column_options" label="选项" min-width="120">
                    <template slot-scope="scope">
                      <div v-if="scope.row.column_type=='单选' || scope.row.column_type=='多选'" class="options-preview">
                        {{scope.row.column_options.join('、')}}
                      </div>
                      <span v-else class="no-options">-</span>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <div class="action-btns">
                        <el-button type="text" size="small" @click="moveUp(scope.$index)" :disabled="scope.$index === 0">
                          <i class="el-icon-arrow-up"></i>
                        </el-button>
                        <el-button type="text" size="small" @click="moveDown(scope.$index)" :disabled="scope.$index === columnData.length - 1">
                          <i class="el-icon-arrow-down"></i>
                        </el-button>
                        <el-button @click="editClick(scope.$index)" type="text" size="small" class="edit-btn">
                          <i class="el-icon-edit"></i> 修改
                        </el-button>
                        <el-button @click="deleteClick(scope.$index)" type="text" size="small" class="delete-btn">
                          <i class="el-icon-delete"></i> 删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 空状态提示 -->
                <div v-if="columnData.length === 0" class="empty-state">
                  <i class="el-icon-s-grid"></i>
                  <p>还没有添加数据列</p>
                  <el-button type="primary" size="small" @click="showAddColumnDialog()">添加第一列</el-button>
                </div>

                <div class="table-footer" v-if="columnData.length > 0">
                  共 <strong>{{columnData.length}}</strong> 个数据列
                </div>
              </div>
            </div>

            <!-- 底部操作按钮 -->
            <div class="form-actions">
              <el-button @click="back" class="btn-default">
                <i class="el-icon-arrow-left"></i> 返回列表
              </el-button>
              <el-button type="primary" @click="saveForm()" class="btn-primary-custom btn-save">
                <i class="el-icon-check"></i> 保存表格
              </el-button>
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!-- 添加/修改列弹窗 -->
    <el-dialog 
      width="500px" 
      :close-on-click-modal="false" 
      :title="field_action_title"
      :visible.sync="addColumnDialogVisible"
      custom-class="custom-dialog">
      
      <el-form ref="columnForm" label-width="90px" size="small">
        <el-form-item label="数据列名" :required="true">
          <el-input 
            v-model="column_name" 
            placeholder="如：姓名、电话、身份证号等">
          </el-input>
        </el-form-item>

        <el-form-item label="数据格式" :required="true">
          <el-select 
            v-model="column_type" 
            placeholder="请选择数据格式" 
            @change="selectColumnType"
            style="width: 100%">
            <el-option 
              v-for="item in columnTypes" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value">
            </el-option>
          </el-select>
          <div v-if="column_type=='单选' || column_type=='多选'" class="edit-options-link">
            <el-button type="text" @click="editSelectItems">
              <i class="el-icon-edit"></i> 编辑选项
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="是否必填" :required="true">
          <el-radio-group v-model="column_optional" size="small">
            <el-radio label="0" border>必须填写</el-radio>
            <el-radio label="1" border>可填可不填</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="填写说明">
          <el-input 
            type="textarea" 
            :rows="2" 
            v-model="column_comment" 
            placeholder="填写时显示的提示说明">
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addColumnDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveColumn()" class="btn-primary-custom">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加选项弹窗 -->
    <el-dialog 
      width="450px" 
      :close-on-click-modal="false" 
      title="添加选项" 
      :visible.sync="addOptionsDialogVisible"
      custom-class="custom-dialog">
      
      <el-form ref="optionsForm" label-width="80px" size="small">
        <el-form-item label="选项列表">
          <el-input 
            type="textarea" 
            :rows="6" 
            v-model="option_list_str" 
            placeholder="请输入选项，每行一个">
          </el-input>
          <div class="input-tip">每行输入一个选项，重复选项会自动去重</div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelOptionsToColumn">取 消</el-button>
        <el-button type="primary" @click="addOptionsToColumn" class="btn-primary-custom">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 保存成功弹窗 -->
    <el-dialog 
      width="400px" 
      :close-on-click-modal="false" 
      title="保存成功" 
      :visible.sync="saveFormSuccessDialogVisible"
      custom-class="custom-dialog success-dialog">
      
      <div class="success-content">
        <i class="el-icon-success"></i>
        <p>表格结构保存成功！</p>
        <p class="sub-text">如果不需要再修改了，可返回列表查看</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveFormSuccessDialogVisible=false" class="btn-primary-custom">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.form_id = this.$route.params.form_id
      this.action = this.$route.params.action

      if (this.action == 'EDIT') {
        this.make_form_title = '修改表格'
        this.loadFormStructure()
      } else {
        this.make_form_title = '新建表格'
      }
    },
    data() {
      return {
        make_form_title: '',
        form_id: '',
        action: '',
        form: '',
        form_fields: [],
        username: '',
        editForm: {
          id: '',
          form_name: '',
          form_comment: '',
          input_pages: 0,
          recieve_notice: ''
        },
        form_rules: {
          form_name: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },
        columnData: [],
        addColumnDialogVisible: false,
        column_name: '',
        column_type: '',
        column_comment: '',
        column_options: [],
        column_optional: '',
        column_field_sample: '',
        columnTypes: [{
            label: '任意内容(无固定格式)',
            value: '文本'
          }, {
            label: '数字(只能填数字)',
            value: '数字'
          }, {
            label: '身份证号(只能填写身份证号)',
            value: '身份证号'
          }, {
            label: '手机号(只能填写手机号)',
            value: '手机号'
          }, {
            label: '年月(格式:年-月)',
            value: '年月'
          }, {
            label: '日期(格式:年-月-日)',
            value: '日期'
          }, {
            label: '日期及时间(格式:年-月-日 时:分)',
            value: '日期时间'
          }, {
            label: '日期范围(格式:年-月-日 至 年-月-日)',
            value: '日期范围'
          }, {
            label: '自动时间(无需填写,系统自动填写填表时间)',
            value: '自动时间'
          }, {
            label: '单选(多个选项中选一个)',
            value: '单选'
          }, {
            label: '多选(多个选项中可选多个)',
            value: '多选'
          }, {
            label: '图片(上传一张图片)',
            value: '图片'
          }, {
            label: '视频(上传一个视频)',
            value: '视频'
          }, {
            label: '文件(上传一个doc、xls、pdf等文件)',
            value: '文件'
          }, {
            label: '条形码(竖线的条形码)',
            value: '条形码'
          }, {
            label: '二维码(方形的二维码)',
            value: '二维码'
          }, {
            label: 'Email邮箱(只能填写邮箱)',
            value: 'Email邮箱'
          }, {
            label: '车牌号(固定格式的)',
            value: '车牌号'
          }, {
            label: '签名(手写签名)',
            value: '签名'
          }
        ],
        addOptionsDialogVisible: false,
        option_list_str: '',
        field_operation_type: '',
        edit_field_index: -1,
        field_action_title: '',
        saveFormSuccessDialogVisible: false
      }
    },
    methods: {
      back() {
        this.$router.go(-1)
      },
      showAddColumnDialog() {
        this.column_name = ''
        this.column_type = ''
        this.column_comment = ''
        this.column_options = []
        this.column_optional = ''
        this.column_field_sample = ''
        this.field_operation_type = 'ADD'
        this.field_action_title = '添加数据列'
        this.addColumnDialogVisible = true
      },
      saveColumn() {
        if (this.column_name === '') {
          this.$message.error('请输入列名!')
          return
        }
        if (this.field_operation_type == 'ADD') {
          if (this.isExistColumn(this.column_name)) {
            this.$message.error('"' + this.column_name + '"列已存在,请更换列名称!')
            return
          }
        }
        if (this.column_type === '') {
          this.$message.error('请选择数据类型!')
          return
        }
        if (this.column_optional === '') {
          this.$message.error('请确认是否必须填写!')
          return
        }

        let column = {
          column_name: this.column_name,
          column_type: this.column_type,
          column_optional: this.column_optional,
          column_comment: this.column_comment,
          column_options: this.column_options,
          column_field_sample: this.column_field_sample
        }

        if (this.field_operation_type == 'ADD') {
          this.columnData.push(column)
        } else {
          this.columnData[this.edit_field_index].column_name = this.column_name
          this.columnData[this.edit_field_index].column_type = this.column_type
          this.columnData[this.edit_field_index].column_optional = this.column_optional
          this.columnData[this.edit_field_index].column_comment = this.column_comment
          this.columnData[this.edit_field_index].column_options = this.getOptionsFromStr(this.option_list_str)
        }

        this.addColumnDialogVisible = false
        this.option_list_str = ''
        this.$forceUpdate()
        this.$message({
          message: '暂存成功！注意：数据只是暂存状态，需要点底部的"保存表格"按钮才会生效哦！',
          type: 'success'
        })
      },
      isExistColumn(column_name) {
        if (this.columnData.length === 0) return false
        for (var i = 0; i < this.columnData.length; i++) {
          let tmpObj = this.columnData[i]
          if (tmpObj.column_name === column_name) {
            return true
          }
        }
        return false
      },
      deleteClick(index) {
        var colName = this.columnData[index].column_name
        let that = this
        that.$confirm('确定要删除"' + colName + '"吗?', '操作提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let tmpColumnArray = []
          for (var i = 0; i < that.columnData.length; i++) {
            if (i !== index) {
              tmpColumnArray.push(that.columnData[i])
            }
          }
          that.columnData = []
          that.columnData = tmpColumnArray
        }).catch(() => {})
      },
      saveForm() {
        if (this.editForm.form_name === '') {
          this.$message.error('请输入表格名称')
          return
        }
        if (this.columnData.length === 0) {
          this.$alert('表格中没有任何列,请先添加表格数据列！')
          return
        }

        let that = this
        let data = {
          username: this.username,
          form_name: this.editForm.form_name,
          form_comment: this.editForm.form_comment,
          recieve_notice: this.editForm.recieve_notice,
          form_input_pages: '1',
          form_columns: JSON.stringify(that.columnData),
          form_id: this.form_id
        }

        var qs = require('qs')
        const load = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_save_form.jsp'
        this.axios.post(
          requestUrl,
          qs.stringify(data), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ).then(function(response) {
          load.close()
          that.saveFormSuccessDialogVisible = true
        }).catch(function() {
          load.close()
        })
      },
      convertOptional(scope) {
        if (scope.row.column_optional === '1') {
          return '可填可不填'
        } else {
          return '必须填写'
        }
      },
      moveUp(index) {
        if (index === 0) {
          this.$message({ message: '已经是第一行了!', type: 'error' })
          return
        }
        let preObj = Object.assign({}, this.columnData[index - 1])
        let currentObj = Object.assign({}, this.columnData[index])

        this.columnData[index - 1].column_name = currentObj.column_name
        this.columnData[index - 1].column_type = currentObj.column_type
        this.columnData[index - 1].column_optional = currentObj.column_optional
        this.columnData[index - 1].column_comment = currentObj.column_comment
        this.columnData[index - 1].column_options = currentObj.column_options

        this.columnData[index].column_name = preObj.column_name
        this.columnData[index].column_type = preObj.column_type
        this.columnData[index].column_optional = preObj.column_optional
        this.columnData[index].column_comment = preObj.column_comment
        this.columnData[index].column_options = preObj.column_options

        this.$forceUpdate()
        this.$message({ message: '上移成功!', type: 'success' })
      },
      moveDown(index) {
        if (index === this.columnData.length - 1) {
          this.$message({ message: '已经是最后一行了!', type: 'error' })
          return
        }
        let nextObj = Object.assign({}, this.columnData[index + 1])
        let currentObj = Object.assign({}, this.columnData[index])

        this.columnData[index + 1].column_name = currentObj.column_name
        this.columnData[index + 1].column_type = currentObj.column_type
        this.columnData[index + 1].column_optional = currentObj.column_optional
        this.columnData[index + 1].column_comment = currentObj.column_comment
        this.columnData[index + 1].column_options = currentObj.column_options

        this.columnData[index].column_name = nextObj.column_name
        this.columnData[index].column_type = nextObj.column_type
        this.columnData[index].column_optional = nextObj.column_optional
        this.columnData[index].column_comment = nextObj.column_comment
        this.columnData[index].column_options = nextObj.column_options

        this.$forceUpdate()
        this.$message({ message: '下移成功!', type: 'success' })
      },
      selectColumnType() {
        if (this.column_type === '单选' || this.column_type === '多选') {
          this.addOptionsDialogVisible = true
        }
      },
      cancelOptionsToColumn() {
        this.addOptionsDialogVisible = false
      },
      addOptionsToColumn() {
        let snsArr = this.getOptionsFromStr(this.option_list_str)
        this.column_options = snsArr
        this.addOptionsDialogVisible = false
      },
      getOptionsFromStr(str) {
        let tmpArray = []
        let snsArr = this.option_list_str.split(/[\r\n]+/)
        if (snsArr.length === 0) {
          return snsArr
        }
        snsArr.forEach((item, index) => {
          if (!item) {
            snsArr.splice(index, 1)
          }
        })
        for (var i = 0; i < snsArr.length; i++) {
          var tmpStr = snsArr[i]
          if (!this.isExistStrInArray(tmpArray, tmpStr)) {
            tmpArray.push(tmpStr)
          }
        }
        return tmpArray
      },
      isExistStrInArray(srcArray, str) {
        var isExist = false
        if (Utils.isEmpty(srcArray)) {
          return false
        } else {
          for (var i = 0; i < srcArray.length; i++) {
            var tmpStr = srcArray[i]
            if (tmpStr == str) {
              isExist = true
              break
            }
          }
        }
        return isExist
      },
      editSelectItems() {
        this.addOptionsDialogVisible = true
      },
      editClick(index) {
        this.field_operation_type = 'EDIT'
        this.edit_field_index = index
        this.field_action_title = '修改数据列'
        var colName = this.columnData[index].column_name
        this.addColumnDialogVisible = true
        this.column_name = colName
        this.column_type = this.columnData[index].column_type
        this.column_optional = '' + this.columnData[index].column_optional
        this.column_comment = this.columnData[index].column_comment
        if (this.column_type == '单选' || this.column_type == '多选') {
          this.option_list_str = this.arrayToLine(this.columnData[index].column_options)
        } else {
          this.option_list_str = ''
        }
      },
      arrayToLine(options) {
        var lines = ''
        if (Utils.isEmpty(options)) {
          return ''
        } else {
          for (var i = 0; i < options.length; i++) {
            if (i == 0) {
              lines = options[0]
            } else {
              lines = lines + '\n' + options[i]
            }
          }
        }
        return lines
      },
      loadFormStructure() {
        console.log('编辑数据')
        let that = this
        var requestUrl = '/form/web/_load_form_structure.jsp'
        const load = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: that.form_id
          }
        }).then(function(response) {
          that.form = response.data.form
          that.editForm.form_name = that.form.form_name
          that.editForm.form_comment = that.form.comment
          that.editForm.recieve_notice = that.form.receive_notice
          that.form_fields = response.data.form_fields
          for (var i = 0; i < that.form_fields.length; i++) {
            let field = that.form_fields[i]
            let field_options = ''
            if (field.field_type == '单选' || field.field_type == '多选') {
              field_options = JSON.parse(field.field_options)
            }
            let column = {
              column_name: field.field_name,
              column_type: field.field_type,
              column_optional: field.optional,
              column_comment: field.field_comment,
              column_options: field_options
            }
            that.columnData.push(column)
          }
          load.close()
          that.$refs.dataList.doLayout()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      }
    }
  }
</script>

<style scoped>
  /* 页面整体 */
  .make-form-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .content-col {
    padding-left: 20px;
  }

  /* 页面标题 */
  .page-header {
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .page-title i {
    color: #1485FB;
    font-size: 26px;
  }

  /* 表单卡片 */
  .form-card {
    background: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  }

  /* 表单分区 */
  .form-section {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #e8e8e8;
  }

  .form-section:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .section-num {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
  }

  .required-tag {
    background: linear-gradient(135deg, #FFCB2F 0%, #ffb700 100%);
    color: #333;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 11px;
    margin-left: 10px;
  }

  /* 表单网格 */
  .form-grid {
    display: grid;
    gap: 20px;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #555;
    padding-bottom: 8px;
  }

  ::v-deep .el-input__inner {
    border-radius: 6px;
  }

  /* 表格包装 */
  .table-wrapper {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
  }

  .column-table {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }

  ::v-deep .column-table .el-table__header-wrapper th {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    color: #495057;
    font-weight: 600;
    font-size: 13px;
    padding: 12px 0;
  }

  .row-num {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
  }

  .type-tag {
    background: #e6f7ff;
    color: #1485FB;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
  }

  .status-badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-badge.required {
    background: #fff2f0;
    color: #cf1322;
  }

  .status-badge.optional {
    background: #f6ffed;
    color: #389e0d;
  }

  .comment-text {
    color: #666;
    font-size: 13px;
  }

  .options-preview {
    color: #666;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
  }

  .no-options {
    color: #999;
  }

  /* 操作按钮 */
  .action-btns {
    display: flex;
    justify-content: center;
    gap: 5px;
  }

  .action-btns .el-button {
    padding: 5px;
  }

  .action-btns .edit-btn {
    color: #1485FB;
  }

  .action-btns .delete-btn {
    color: #f56c6c;
  }

  /* 空状态 */
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    background: #fff;
    border-radius: 8px;
  }

  .empty-state i {
    font-size: 48px;
    color: #d9d9d9;
    margin-bottom: 15px;
  }

  .empty-state p {
    color: #999;
    margin-bottom: 20px;
  }

  /* 表格底部 */
  .table-footer {
    text-align: right;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #e8e8e8;
    color: #666;
    font-size: 14px;
  }

  /* 表单操作按钮 */
  .form-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #e8e8e8;
  }

  .btn-default {
    padding: 12px 30px;
    border-radius: 8px;
  }

  .btn-save {
    padding: 12px 40px;
    font-size: 16px;
  }

  /* 主按钮样式 */
  .btn-primary-custom {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(20, 133, 251, 0.3);
  }

  /* 弹窗样式 */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 15px 20px;
  }

  ::v-deep .custom-dialog .el-dialog__title {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 25px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 20px;
  }

  ::v-deep .success-dialog .el-dialog__header {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
  }

  .edit-options-link {
    margin-top: 8px;
  }

  .input-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
  }

  /* 成功弹窗内容 */
  .success-content {
    text-align: center;
    padding: 20px;
  }

  .success-content i {
    font-size: 64px;
    color: #2CCB92;
    margin-bottom: 15px;
  }

  .success-content p {
    font-size: 16px;
    color: #333;
    margin: 0;
  }

  .success-content .sub-text {
    font-size: 14px;
    color: #999;
    margin-top: 10px;
  }

  /* 响应式 */
  @media (max-width: 768px) {
    .main-content {
      padding: 10px;
    }

    .content-col {
      padding-left: 0;
      margin-top: 15px;
    }

    .form-card {
      padding: 20px;
    }

    .section-header {
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
    }

    .form-actions {
      flex-direction: column;
    }
  }
</style>

<style>
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/make_form.vue